import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit, OnDestroy {
  message = 'Verificando enlace...';
  status: 'loading' | 'ready' | 'success' | 'error' = 'loading';
  error = '';
  loading = false;
  token = '';
  private redirectTimer: ReturnType<typeof setTimeout> | null = null;

  form = this.fb.group(
    {
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8)
        ]
      ],
      confirmPassword: ['', Validators.required]
    },
    {
      validators: (group) => {
        const pass = group.get('password')?.value;
        const confirm = group.get('confirmPassword')?.value;
        return pass && confirm && pass !== confirm ? { mismatch: true } : null;
      }
    }
  );

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.showInvalid();
      return;
    }
    this.token = token;

    this.http
      .get<any>(`${environment.serverUrl}/auth/recovery/${token}`)
      .pipe(
        tap((ok: any) => {
          const isOk =
            ok === true ||
            ok === 'true' ||
            ok === 1 ||
            (ok &&
              typeof ok === 'object' &&
              (ok.ok === true || ok.success === true || ok.data === true));
          if (isOk) {
            this.status = 'ready';
            this.message = '';
          } else {
            this.showInvalid();
          }
        }),
        catchError(() => {
          this.showInvalid();
          return of(null);
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  submit(): void {
    if (this.form.invalid || this.loading || !this.token) return;
    this.loading = true;
    this.error = '';

    this.http
      .put<any>(`${environment.serverUrl}/auth/recovery/${this.token}`, {
        password: this.form.value.password
      })
      .pipe(
        tap(() => {
          this.status = 'success';
          this.message =
            'Contraseña actualizada correctamente. Redirigiendo al login...';
          this.form.disable();
        }),
        catchError(() => {
          this.error = 'No se pudo actualizar la contraseña.';
          return of(null);
        }),
        finalize(() => {
          this.loading = false;
          if (this.status === 'success') {
            this.scheduleRedirect();
          }
        })
      )
      .subscribe();
  }

  private showInvalid(): void {
    this.status = 'error';
    this.message = 'El enlace no es válido o ha caducado.';
  }

  private scheduleRedirect(): void {
    if (this.redirectTimer) return;
    this.redirectTimer = setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 2500);
  }
}
